import { PATHS_NAME } from '@shared/routers/consts/pathsName.js';
import { ROUTES_META } from '@shared/routers/consts/metaObj.js';

export const ROUTES = {
  [PATHS_NAME.MAIN]: {
    path: '/',
    name: PATHS_NAME.MAIN,
    meta: ROUTES_META[PATHS_NAME.MAIN],
    component: () => import('@pages/Main/MainPage.vue'),
  },

  [PATHS_NAME.CALENDAR]: {
    path: '/calendar',
    name: PATHS_NAME.CALENDAR,
    component: () => import('@pages/Calendar/CalendarPage.vue'),
    meta: ROUTES_META[PATHS_NAME.CALENDAR],
  },

  [PATHS_NAME.FORECASTERS]: {
    path: '/forecasters',
    name: PATHS_NAME.FORECASTERS,
    component: () => import('@pages/Forecasters/ForecastersPage.vue'),
    meta: ROUTES_META[PATHS_NAME.FORECASTERS],
  },

  [PATHS_NAME.SIGNALS]: {
    path: '/signals',
    name: PATHS_NAME.SIGNALS,
    component: () => import('@pages/Signals/SignalsPage.vue'),
    meta: ROUTES_META[PATHS_NAME.SIGNALS],
  },

  [PATHS_NAME.FEEDBACK]: {
    path: '/report',
    name: PATHS_NAME.FEEDBACK,
    component: () => import('@pages/Report/ReportPage.vue'),
  },

  [PATHS_NAME.TWITTER_HYPE]: {
    path: '/twitter-hype',
    name: PATHS_NAME.TWITTER_HYPE,
    component: () => import('@pages/TwitterHype/TwitterHype.vue'),
  },

  [PATHS_NAME.RULES.TERMS]: {
    path: '/rules/terms',
    name: PATHS_NAME.RULES.TERMS,
    component: () => import('@pages/Rules/TermsPage.vue'),
    meta: ROUTES_META[PATHS_NAME.RULES.TERMS],
  },

  [PATHS_NAME.RULES.PRIVACY]: {
    path: '/rules/privacy',
    name: PATHS_NAME.RULES.PRIVACY,
    component: () => import('@pages/Rules/PrivacyPage.vue'),
    meta: ROUTES_META[PATHS_NAME.RULES.PRIVACY],
  },
  [PATHS_NAME.SCANNER]:{
    path: '/screener',
    name: PATHS_NAME.SCANNER,
    component: () => import('@pages/Scanner/ScannerPage.vue'),
    meta: ROUTES_META[PATHS_NAME.SCANNER],
  },
  [PATHS_NAME.STOREROOM]:{
    path: '/storeroom',
    name: PATHS_NAME.STOREROOM,
    component: () => import('@pages/Storeroom/Storeroom.vue'),
    meta: ROUTES_META[PATHS_NAME.STOREROOM],
  },
  [PATHS_NAME.KNOWLEDGE_BASE]: {
    path: '/knowledge-base/:slug?',
    name: PATHS_NAME.KNOWLEDGE_BASE,
    component: () => import('@pages/KnowledgeBase/KnowledgeBase.vue'),
    meta: ROUTES_META[PATHS_NAME.KNOWLEDGE_BASE],
  },
  [PATHS_NAME.POLYMARKET]: {
    path: '/polymarket',
    name: PATHS_NAME.POLYMARKET,
    component: () => import('@pages/Polymarket/PolymarketPage.vue'),
    meta: ROUTES_META[PATHS_NAME.POLYMARKET],
  },
  /* ------------------------------------------------- CONTENT ---------------------------------------------------- */
  [PATHS_NAME.ARTICLES]: {
    path: '/:type(news|material|opinion|signal)/:id',
    name: PATHS_NAME.ARTICLES,
    component: () => import('@pages/Article/PageArticle.vue'),
    meta: ROUTES_META[PATHS_NAME.ARTICLES],
  },
  [PATHS_NAME.REDIRECT_ARTICLE]: {
    path: '/:type(materials|opinions)/:id',
    redirect: (to) => {
      const { id, type } = to.params;
      const typeMapping = {
        materials: `/material/${id}`,
        opinions: `/opinion/${id}`,
      };
      return typeMapping[type];
    },
  },
  /* --------------------------------------------------- USER ---------------------------------------------------- */
  [PATHS_NAME.USER.MAIN]: {
    path: '/user',
    name: PATHS_NAME.USER.MAIN,
    component: () => import('@pages/User/User.vue'),
    meta: ROUTES_META[PATHS_NAME.USER.MAIN],
    children: [
      {
        path: 'settings',
        name: PATHS_NAME.USER.SETTINGS,
        component: () => import('@pages/User/modules/Settings/Settings.vue'),
        meta: ROUTES_META[PATHS_NAME.USER.SETTINGS],
      },
      {
        path: 'comments',
        name: PATHS_NAME.USER.COMMENTS,
        component: () => import('@pages/User/modules/Comments/UserComments.vue'),
        meta: ROUTES_META[PATHS_NAME.USER.COMMENTS],
      },
      {
        path: 'subscription',
        name: PATHS_NAME.USER.SUBSCRIPTION,
        component: () => import('@pages/User/modules/Subscription/Subscription.vue'),
        meta: ROUTES_META[PATHS_NAME.USER.SUBSCRIPTION],
      },
      {
        path: 'subscription/purchase',
        name: PATHS_NAME.USER.SUBSCRIPTION_PURCHASE,
        component: () => import('@pages/User/modules/Subscription/components/SubscriptionPurchase/SubscriptionPurchase.vue'),
        meta: ROUTES_META[PATHS_NAME.USER.SUBSCRIPTION_PURCHASE],
      },
      {
        path: 'subscription/wallets',
        name: PATHS_NAME.USER.SUBSCRIPTION_WALLETS,
        component: () => import('@pages/User/modules/Wallets/UserWallets.vue'),
        meta: ROUTES_META[PATHS_NAME.USER.SUBSCRIPTION_WALLETS],
      },
      {
        path: 'give-gifts',
        name: PATHS_NAME.USER.GIVE_GIFT,
        component: () => import('@pages/User/modules/GiveGifts/GiveGifts.vue'),
        meta: ROUTES_META[PATHS_NAME.USER.GIVE_GIFT],
      },
      {
        path: 'gifts',
        name: PATHS_NAME.USER.GIFT,
        component: () => import('@pages/User/modules/Gifts/UserActiveGifts.vue'),
        meta: ROUTES_META[PATHS_NAME.USER.GIFT],
      },
      {
        path: 'alpha',
        name: PATHS_NAME.USER.ALPHA,
        component: () => import('@pages/User/modules/Alpha/Alpha.vue'),
        meta: ROUTES_META[PATHS_NAME.USER.ALPHA],
      },
    ]
  },

  /* ------------------------------------------------ OTHER USERS -------------------------------------------------- */
  [PATHS_NAME.OTHER_USERS.MAIN]: {
    path: '/users/:username',
    name: PATHS_NAME.OTHER_USERS.MAIN,
    component: () => import('@pages/User/User.vue'),
    children: [
      {
        path: 'profile',
        name: PATHS_NAME.OTHER_USERS.PROFILE,
        component: () => import('@pages/User/modules/Settings/Settings.vue'),
      },
      {
        path: 'comments',
        name: PATHS_NAME.OTHER_USERS.COMMENTS,
        component: () => import('@pages/User/modules/Comments/UserComments.vue'),
      },
      {
        path: 'alpha',
        name: PATHS_NAME.OTHER_USERS.ALPHA,
        component: () => import('@pages/User/modules/Alpha/Alpha.vue'),
      },

    ]
  },

  /* ------------------------------------------------ AUTH -------------------------------------------------- */
  [PATHS_NAME.GOOGLE_LOGIN]: {
    path: '/google/login/callback/',
    name: PATHS_NAME.GOOGLE_LOGIN,
    component: () => import('@pages/Auth/GoogleAuth/GoogleLogin.vue'),
  },

  [PATHS_NAME.GOOGLE_LINK]: {
    path: '/google/link/callback/',
    name: PATHS_NAME.GOOGLE_LINK,
    component: () => import('@pages/User/modules/Settings/components/LinkedSocialAccounts/GoogleLink.vue'),
  },

  [PATHS_NAME.TELEGRAM_LOGIN]: {
    path: '/telegram/login/callback/',
    name: PATHS_NAME.TELEGRAM_LOGIN,
    component: () => import('@pages/Auth/TelegramAuth/TelegramLogin2.vue'),
  },

  [PATHS_NAME.TELEGRAM_LINK]: {
    path: '/telegram/link/callback/',
    name: PATHS_NAME.TELEGRAM_LINK,
    component: () => import('@pages/User/modules/Settings/components/LinkedSocialAccounts/TelegramLink.vue'),
  },

  [PATHS_NAME.CONFIRM_EMAIL]: {
    path: '/confirm-email/',
    name: PATHS_NAME.CONFIRM_EMAIL,
    component: () => import('@pages/Auth/ConfirmEmail.vue'),
  },

  [PATHS_NAME.PENDING_CONFIRM_EMAIL]: {
    path: '/pending-confirm-email/',
    name: PATHS_NAME.PENDING_CONFIRM_EMAIL,
    component: () => import('@pages/Auth/PendingConfirmEmail.vue'),
  },

  [PATHS_NAME.RESET_PASS]: {
    path: '/password-reset-confirm/',
    name: PATHS_NAME.RESET_PASS,
    component: () => import('@pages/Auth/ResetPass/AuthResetPass.vue'),
  },

  [PATHS_NAME.NOT_FOUND]: {
    path: '/:pathMatch(.*)*',
    name: PATHS_NAME.NOT_FOUND,
    component: () => import('@pages/NotFound/NotFoundPage.vue'),
  }
}
